import Types from '../types';

export default (reducerState = {}, action) => {
  switch (action.type) {
    case Types.SET_COURSE:
      return action.payload;
    default:
      return reducerState;
  }
};
